import { useEffect } from "react";
import { Provider } from "react-redux";
import {
  axiosInstance,
  requestFailure,
  requestSuccess,
} from "./core/http/httpClient";
import {
  axiosInstance as twilioAxiosInstance,
  requestFailure as twilioRequestFailure,
  requestSuccess as twilioRequestSuccess,
} from "./core/http/twilioClient";
import { assetActions } from "./ducks/asset";
import { useEarlyBird } from "./hooks/useEarlyBird";
import { RouteConfig } from "./RouteConfig";
import { store } from "./store";

function App() {
  const {
    checkCampaign,
    handleWhenHasEarlyBirdData,
    isInPageToShowModal,
    isDirectAccess,
    menusInCart,
    campaign,
  } = useEarlyBird();

  useEffect(() => {
    store.dispatch(assetActions.fetchMessages.started({}));
    store.dispatch(assetActions.fetchSettings.started({}));
    store.dispatch(assetActions.fetchMaintenance.started({}));

    axiosInstance.interceptors.response.use(
      (config) => requestSuccess(config),
      (config) => requestFailure(config, store),
    );

    twilioAxiosInstance.interceptors.response.use(
      (config) => twilioRequestSuccess(config),
      (config) => twilioRequestFailure(config, store),
    );
  }, []);

  useEffect(() => {
    const menusEarlyBirdInCart = menusInCart?.some((menu) => menu.isEarlyBird);
    const hasEarlyBirdData = !!campaign || !!menusEarlyBirdInCart;
    if (!hasEarlyBirdData || !isInPageToShowModal) return checkCampaign();
    if (isInPageToShowModal && isDirectAccess && hasEarlyBirdData)
      handleWhenHasEarlyBirdData();
  }, []);

  return (
    <Provider store={store}>
      <RouteConfig />
    </Provider>
  );
}

export default App;
